import { MULTI_LAYOUT_SLUG } from '@/types/pages/layout';
import imgColumn2 from '@/assets/images/storeManagement/multiLayout/column-2.png';
import imgColumn3 from '@/assets/images/storeManagement/multiLayout/column-3.png';
import imgLandscapeGrid4 from '@/assets/images/storeManagement/multiLayout/landscape-grid-4.png';
import imgLandscapeList2 from '@/assets/images/storeManagement/multiLayout/landscape-list-2.png';
import imgLandscapeList5 from '@/assets/images/storeManagement/multiLayout/landscape-list-5.png';
import imgLandscapeRange6 from '@/assets/images/storeManagement/multiLayout/landscape-range-6.png';
import imgList2 from '@/assets/images/storeManagement/multiLayout/list-2.png';
import imgPortraitGrid4 from '@/assets/images/storeManagement/multiLayout/portrait-grid-4.png';
import imgPortraitList3 from '@/assets/images/storeManagement/multiLayout/portrait-list-3.png';
import imgPortraitList6 from '@/assets/images/storeManagement/multiLayout/portrait-list-6.png';
import imgPortraitRange8 from '@/assets/images/storeManagement/multiLayout/portrait-range-8.png';
import { decodeMac } from '@/utils/inputUtils';

export const MULTI_LAYOUT_IMG: Record<MULTI_LAYOUT_SLUG, string> = {
    [MULTI_LAYOUT_SLUG.COLUMN_2]: imgColumn2,
    [MULTI_LAYOUT_SLUG.COLUMN_3]: imgColumn3,
    [MULTI_LAYOUT_SLUG.LANDSCAPE_GRID_4]: imgLandscapeGrid4,
    [MULTI_LAYOUT_SLUG.LANDSCAPE_LIST_2]: imgLandscapeList2,
    [MULTI_LAYOUT_SLUG.LANDSCAPE_LIST_5]: imgLandscapeList5,
    [MULTI_LAYOUT_SLUG.LANDSCAPE_RANGE_6]: imgLandscapeRange6,
    [MULTI_LAYOUT_SLUG.LIST_2]: imgList2,
    [MULTI_LAYOUT_SLUG.PORTRAIT_GRID_4]: imgPortraitGrid4,
    [MULTI_LAYOUT_SLUG.PORTRAIT_LIST_3]: imgPortraitList3,
    [MULTI_LAYOUT_SLUG.PORTRAIT_LIST_6]: imgPortraitList6,
    [MULTI_LAYOUT_SLUG.PORTRAIT_RANGE_8]: imgPortraitRange8,
};

export const COOL_DOWN_MS = 200; // 掃完後等待時間

export const DUPLICATE_TTL_MS = 800; // 相同內容的抑制視窗

export const getScrollTop = (scroller: Window | HTMLDivElement) => {
    return scroller instanceof Window ? window.scrollY : scroller.scrollTop;
};

export const setScrollTop = (scroller: Window | HTMLDivElement, top: number) => {
    if (scroller instanceof Window) window.scrollTo({ top, behavior: 'auto' });
    else scroller.scrollTo({ top, behavior: 'auto' });
};

/** 回傳目標是否「在可視區內」（含 margin 緩衝） */
export const isVisibleInScroller = (el: HTMLDivElement, scroller: HTMLDivElement, margin = 0): boolean => {
    const sRect = scroller.getBoundingClientRect();
    const eRect = el.getBoundingClientRect();

    const sTop = getScrollTop(scroller);
    const elTop = eRect.top - sRect.top + sTop;
    const elBottom = elTop + eRect.height;

    const visibleTop = sTop + margin;
    const visibleBottom = sTop + scroller.clientHeight - margin;

    return elTop >= visibleTop && elBottom <= visibleBottom;
};

/** 只在需要時，做「最小位移」把元素捲進 scroller 可視區 */
export const ensureVisibleInScroller = (el: HTMLDivElement, scroller: HTMLDivElement, margin = 0): void => {
    const sRect = scroller.getBoundingClientRect();
    const eRect = el.getBoundingClientRect();

    const sTop = getScrollTop(scroller);
    const elTop = eRect.top - sRect.top + sTop;
    const elBottom = elTop + eRect.height;

    const visibleTop = sTop + margin;
    const visibleBottom = sTop + scroller.clientHeight - margin;

    if (elBottom > visibleBottom) {
        // 往下超出：往下捲「剛好露出底部」
        setScrollTop(scroller, sTop + (elBottom - visibleBottom));
    } else if (elTop < visibleTop) {
        // 往上超出：往上捲「剛好露出頂部」
        setScrollTop(scroller, sTop - (visibleTop - elTop));
    }
};

export const SETTING_FLAG: Record<string, boolean> = {
    '1': true,
    '0': false,
};

export const ERROR_CODE_MAP: Record<string, string> = {
    '0x020003': 'ESL not found. Re-Scan.',
    '0x020004': 'ESL can’t be used in this store. Use another.',
};

export const validateEslMac = (mac: string): boolean => {
    mac = mac.trim().toUpperCase();
    if (mac.length === 10 && mac.substring(0, 2) === '++') {
        mac = mac.substring(2);
        mac = decodeMac(mac);
    }

    if (mac.length === 12 && /^[0-9A-F]+$/.test(mac)) {
        return true;
    }

    return false;
};
